import _get from "lodash/get";
import styled, { css } from 'styled-components';
import formTheme from '../../styles/formTheme';
var CheckboxLabel = styled.span.withConfig({
  displayName: "CheckboxLabel",
  componentId: "sc-1rvioj9-0"
})(["color:", ";display:block;", ""], function (props) {
  return _get(props, "theme.form.checkbox.label.color[" + props.skin + "].default", formTheme.form.checkbox.label.color[props.skin].default);
}, function (props) {
  return props.disabledValue && css(["color:", ";cursor:not-allowed;"], _get(props, "theme.form.checkbox.label.color[" + props.skin + "].disabled", formTheme.form.checkbox.label.color[props.skin].disabled));
});
export default CheckboxLabel;